<template>
  <div
    class="col-12 text-muted mt-5"
    v-html="$settings.version + ' ' + $settings.copyRight"
  ></div>
</template>

<script>
export default {
  name: "Footer"
};
</script>
